module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/acknowledgements-html.json
// module id = 699
// module chunks = 64467390377425